const React = require("react");

function ChevronDoubleUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 11l7-7 7 7M5 19l7-7 7 7"
  }));
}

module.exports = ChevronDoubleUpIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ChevronDoubleUpIcon.js
 ** module id = 474
 ** module chunks = 0
 **/